const bxpFormAjaxParamsDefault = {
  ajaxurl: "http://somerandomurl.com.co",
  nonce: "2d7d7b282a"
};
export const AjaxMixin = {
  data() {
    return {
      ajaxParams: process.env.NODE_ENV === "production" ? bxpFormAjaxParams : bxpFormAjaxParamsDefault
    };
  }
};
